/* Sidewalk Promo JS */
document.addEventListener("DOMContentLoaded", () => {
  const widget = document.getElementById("SidewalkPromoShareWidget");
  if (!widget) return;

  const shareBtn = document.getElementById("SPShareBtn");
  const options = document.getElementById("SPShareOptions");
  const qrCodeContainer = document.getElementById("SPQRCode");

  // Get current page URL dynamically
  let shareUrl = window.location.href;

  // Append attribution code code and optional UTM parameters if available
  const url = new URL(shareUrl);
  const attributionCode = localStorage.getItem('attribution_code');
  if (attributionCode) {
    url.searchParams.set("ref", attributionCode);
  }

  // UTM parameters with optional defaults
  const utmDefaults = {
    utm_source: "sidewalkpromo",
    utm_medium: "share_widget",
    utm_campaign: "default_campaign",
    utm_term: "",
    utm_content: ""
  };

  Object.entries(utmDefaults).forEach(([key, defaultVal]) => {
    const val = localStorage.getItem(key) || defaultVal;
    if (val) url.searchParams.set(key, val);
  });

  shareUrl = url.toString();

  // Show QR code
  function generateQRCode(url) {
    qrCodeContainer.innerHTML = "";
    new QRCode(qrCodeContainer, {
      text: url,
      width: 128,
      height: 128,
      colorDark: "#000000",
      colorLight: "#ffffff",
    });
  }

  generateQRCode(shareUrl);

  // Toggle options on desktop
  shareBtn.addEventListener("click", (e) => {
    // Native share for mobile if supported
    if (navigator.share) {
      navigator.share({
        title: document.title,
        url: shareUrl,
      }).catch(console.error);
    } else {
      options.classList.toggle("hidden");
    }
  });

  // Copy URL
  options.querySelector(".sp-copy-url").addEventListener("click", () => {
    navigator.clipboard.writeText(shareUrl).then(() => {
      alert("Copied to clipboard!");
    });
  });

  // WhatsApp
  options.querySelector(".sp-whatsapp").addEventListener("click", () => {
    window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(shareUrl)}`, "_blank");
  });

  // SMS
  options.querySelector(".sp-sms").addEventListener("click", () => {
    window.location.href = `sms:?&body=${encodeURIComponent(shareUrl)}`;
  });

  // Email
  options.querySelector(".sp-email").addEventListener("click", () => {
    window.location.href = `mailto:?subject=${encodeURIComponent(document.title)}&body=${encodeURIComponent(shareUrl)}`;
  });
});
